import {MapDescriptor} from './MapTypes';
import {NeonBlossomMapObject} from './NeonBlossomMap/NeonBlossomMap';

/**
 * All the maps used in the game
 */
export const MAPS: { [key: string]: MapDescriptor } = {
    NEON_BLOSSOM: NeonBlossomMapObject
};